import { PIECE_TYPES } from './tetrominoes';
import type { TetrominoType } from './types';

function nextRandom(seed: number): [number, number] {
  const nextSeed = (Math.imul(seed, 1664525) + 1013904223) >>> 0;
  return [nextSeed / 0x1_0000_0000, nextSeed];
}

export function shuffledBag(seed: number): { bag: TetrominoType[]; seed: number } {
  const bag = [...PIECE_TYPES];
  let currentSeed = seed >>> 0;

  for (let index = bag.length - 1; index > 0; index -= 1) {
    const [value, nextSeed] = nextRandom(currentSeed);
    currentSeed = nextSeed;
    const swapIndex = Math.floor(value * (index + 1));
    [bag[index], bag[swapIndex]] = [bag[swapIndex], bag[index]];
  }

  return { bag, seed: currentSeed };
}
